import { render, staticRenderFns } from "./ANewInstitucion.vue?vue&type=template&id=e637afda"
import script from "./ANewInstitucion.vue?vue&type=script&lang=js"
export * from "./ANewInstitucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports